export default "__VITE_ASSET__nXL8gpbJ__"